module.exports = __webpack_public_path__ + "static/media/spotify-color.9f85deeb.svg";